(function ($) {
  $(document).ready(function () {
    // Utility: Watch for hidden Shopify sections (e.g. from A/B testing CSS) and remove ghost margins
    const sectionObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        // If a section is visually collapsed to 0 height (like when Crazy Egg hides its child)
        if (entry.contentRect.height === 0) {
          entry.target.classList.add("is-hidden-by-experiment");
        } else {
          entry.target.classList.remove("is-hidden-by-experiment");
        }
      });
    });
    document.querySelectorAll(".shopify-section").forEach((sec) => sectionObserver.observe(sec));

    // Default to Edition panel in Drawer when edition-print buttons are clicked.
    const editionPrintButton = document.querySelectorAll(".edition-print");
    editionPrintButton.forEach((btn) => {
      btn.addEventListener("click", function () {
        const authenticityButton = document.getElementById("authenticityButton");
        const authenticityButtonAnchor = authenticityButton.querySelector("a");
        authenticityButtonAnchor.click();
      });
    });

    $(document).on("click", ".leadTimeTrigger", function (e) {
      const panelID = $(this).attr("data-drawer-panel");
      const thePanel = document.getElementById(panelID);
      const theLeadTimeDrawer = document.getElementById("leadTimeDrawer");
      if (thePanel) {
        $(".lead-time-content").hide();
        thePanel.style.display = "block";
        theLeadTimeDrawer.classList.add("active");
      }
    });

    $(document).on("click", "#closeLeadTimeDrawer", function (e) {
      const theLeadTimeDrawer = document.getElementById("leadTimeDrawer");
      theLeadTimeDrawer.classList.remove("active");
      $(".lead-time-content").hide();
    });

    /*Product Hint*/
    $(".hint-description").appendTo("body");

    $(".hint-block .hint").on({
      mouseenter: function () {
        var dataHint = $(this).data("hint");
        var mouseX = 0,
          mouseY = 0;
        var xp = 0,
          yp = 0;

        $(this).mousemove(function (e) {
          mouseX = e.pageX;
          mouseY = e.pageY;

          $(".hint-description").each(function () {
            if ($(this).data("hint-desc") == dataHint) {
              $(this).addClass("hint-hovered");
              if ($(this).hasClass("hint-hovered")) {
                $(this).css({
                  top: mouseY + 20 + "px",
                  left: mouseX - $(this).outerWidth() + 30 + "px",
                });
                var pos = $(this).position(),
                  posX = pos.left;
                if (posX < 0 || posX == 15) {
                  $(this).css("left", "15px");
                }
              } else {
                $(this).removeClass("hint-hovered");
              }
            }
          });
        });
      },
      mouseleave: function () {
        $(".hint-description").removeClass("hint-hovered");
      },
    });

    /*Grid swatches oh hover changing*/
    $(".cb-product-card").each(function () {
      var $card = $(this);
      var defaultFrameColorClass = $card.data("default-frame-color-class") || "frame-color--black";

      function getFrameColorClassFromSwatch($swatch) {
        const frameToken = (($swatch.attr("class") || "").match(/(?:^|\s)([a-z0-9-]+)-frame(?:\s|$)/i) || [])[1];
        if (!frameToken || frameToken === "default") return defaultFrameColorClass;
        if (frameToken === "no") return "frame-color--none";
        return normalizeFrameColorClass(frameToken);
      }

      function setCardFrameClasses($swatch) {
        if (!$swatch || !$swatch.length) return;
        const frameColorClass = getFrameColorClassFromSwatch($swatch);
        $card.find(".card__media.main_product_card_media .frame").each(function () {
          const frameColorClasses = (this.className.match(/frame-color--[^\s]+/g) || []).join(" ");
          if (frameColorClasses) {
            $(this).removeClass(frameColorClasses);
          }
          $(this).addClass(frameColorClass);
        });
      }

      // Default to the selected frame on load if available
      var $defaultFrame = $card.find(".cb-swatch-item.default-frame");
      if ($defaultFrame.length > 0) {
        // Use requestAnimationFrame to ensure the DOM is ready for style changes
        requestAnimationFrame(function () {
          setCardFrameClasses($defaultFrame);
        });
      }

      $card
        .find(".cb-swatch-item")
        .on("mouseenter", function () {
          setCardFrameClasses($(this));
        })
        .on("mouseout", function () {
          var $default = $card.find(".cb-swatch-item.default-frame");
          if ($default.length > 0) {
            setCardFrameClasses($default);
          } else {
            $card.find(".card__media.main_product_card_media .frame").each(function () {
              const frameColorClasses = (this.className.match(/frame-color--[^\s]+/g) || []).join(" ");
              if (frameColorClasses) {
                $(this).removeClass(frameColorClasses);
              }
              $(this).addClass(defaultFrameColorClass);
            });
          }
        });
    });

    function changeTheFrameImages($this, option_class) {
      if ($this && !$this.hasClass("noframe")) {
        if ($(".main-product-gallery div:not(.other) .card__media").length > 1) {
          $(".size-and-more-detail-tab-item-card")
            .find(".size-and-more-img-wrap")
            .css("background-image", "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url") + ")");
          $(".main-product-gallery div:not(.other) .card__media.main_product_card_media").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url-ns") + ")",
          );
          $(".main-product-gallery div:not(.other) .card__media.main_product_card_media:last-child").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url") + ")",
          );
          $(".main-product-gallery div:not(.other) .card__media.wall_table_preview").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url-ns") + ")",
          );
          $(".main-product-gallery div:not(.other) .card__media.wall_table_preview:last-child").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url") + ")",
          );
          $(".product-images-zoom-slider .card__media.main_product_card_media").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url-ns") + ")",
          );
          $(".product-images-zoom-slider .card__media.main_product_card_media:last-child").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url") + ")",
          );
          $(".product-images-zoom-slider .card__media.wall_table_preview").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url-ns") + ")",
          );
          $(".product-images-zoom-slider .card__media.wall_table_preview:last-child").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url") + ")",
          );
        } else {
          $(".main-product-gallery div:not(.other) .card__media").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url") + ")",
          );
          $(".product-images-zoom-slider .card__media").css(
            "background-image",
            "url(" + $(`.${option_class} #` + $this.attr("for")).attr("data-url") + ")",
          );
        }
      } else {
        if (!$this.hasClass("noframe")) {
          $(".size-and-more-detail-tab-item-card").find(".size-and-more-img-wrap").css("background-image", "none");
          $(".main-product-gallery div:not(.other) .card__media.main_product_card_media").css("background-image", "none");
          $(".main-product-gallery div:not(.other) .card__media.main_product_card_media:last-child").css(
            "background-image",
            "none",
          );
          $(".main-product-gallery div:not(.other) .card__media.wall_table_preview").css("background-image", "none");
          $(".main-product-gallery div:not(.other) .card__media.wall_table_preview:last-child").css(
            "background-image",
            "none",
          );
          $(".product-images-zoom-slider .card__media.main_product_card_media").css("background-image", "none");
          $(".product-images-zoom-slider .card__media.main_product_card_media:last-child").css("background-image", "none");
          $(".product-images-zoom-slider .card__media.wall_table_preview").css("background-image", "none");
          $(".product-images-zoom-slider .card__media.wall_table_preview:last-child").css("background-image", "none");

          $(".main-product-gallery div:not(.other) .card__media").css("background-image", "none");
          $(".product-images-zoom-slider .card__media").css("background-image", "none");
        }
      }
    }

    //Product page option frames changer - only handle visual updates, not variant selection
    $(document).on("click", ".option-framing label", function () {
      // Add a small delay to let the variant selection complete first
      setTimeout(() => {
        if ($(this).closest(".drawer__upsell-main-content").length) {
          if ($(".drawer__upsell-main-content div:not(.other) .card__media").length > 1) {
            $(".size-and-more-detail-tab-item-card")
              .find(".size-and-more-img-wrap")
              .css("background-image", "url(" + $(".option-framing #" + $(this).attr("for")).attr("data-url") + ")");
            $(".drawer__upsell-main-content div:not(.other) .card__media.main_product_card_media").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).attr("data-url-ns") + ")",
            );
            $(".drawer__upsell-main-content div:not(.other) .card__media.main_product_card_media:last-child").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).attr("data-url") + ")",
            );
            $(".drawer__upsell-main-content div:not(.other) .card__media.wall_table_preview").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).attr("data-url-ns") + ")",
            );
            $(".drawer__upsell-main-content div:not(.other) .card__media.wall_table_preview:last-child").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).attr("data-url") + ")",
            );
          } else {
            $(".drawer__upsell-main-content div:not(.other) .card__media").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).attr("data-url") + ")",
            );
          }
        } else {
          // changeTheFrameImages($(this), 'option-framing');
        }
      }, 50);
    });

    $(document).on("click", ".option-frame-style label", function () {
      // Add a small delay to let the variant selection complete first
      setTimeout(() => {
        if ($(this).closest(".drawer__upsell-main-content").length) {
          if ($(".drawer__upsell-main-content div:not(.other) .card__media").length > 1) {
            $(".size-and-more-detail-tab-item-card")
              .find(".size-and-more-img-wrap")
              .css("background-image", "url(" + $(".option-framing #" + $(this).attr("for")).data("url") + ")");
            $(".drawer__upsell-main-content div:not(.other) .card__media.main_product_card_media").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).data("url-ns") + ")",
            );
            $(".drawer__upsell-main-content div:not(.other) .card__media.main_product_card_media:last-child").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).data("url") + ")",
            );
            $(".drawer__upsell-main-content div:not(.other) .card__media.wall_table_preview").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).data("url-ns") + ")",
            );
            $(".drawer__upsell-main-content div:not(.other) .card__media.wall_table_preview:last-child").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).data("url") + ")",
            );
          } else {
            $(".drawer__upsell-main-content div:not(.other) .card__media").css(
              "background-image",
              "url(" + $(".option-framing #" + $(this).attr("for")).data("url") + ")",
            );
          }
        } else {
          // changeTheFrameImages($(this), 'option-frame-style');
        }
      }, 50);
    });

    // Update the frame images when clicking frame style options
    // $(document).on('click', '.option-frame-style label',function(){
    //   // If the No Frame option was clicked update the frame image (will always remove the images)
    //   if($(this).hasClass('noframe')){
    //     //$('.option-frame-color').find('.option-label .option-title').text('');
    //     changeTheFrameImages();
    //     //$('.option-frame-color').find('input:checked').prop('checked', false);

    //   } else {
    //     // When toggling between No Frame and Frame style options, go back to the currently selected frame color option and images
    //     $('.option-frame-color').find('input:checked+label').trigger('click');
    //   }
    // });

    // Product page option frames changer default without click
    if ($("product-info .option-framing input:checked").length > 0) {
      if ($(".main-product-gallery div:not(.other) .card__media").length > 1) {
        console.log(">1");
        $(".size-and-more-detail-tab-item-card")
          .find(".size-and-more-img-wrap")
          .css("background-image", "url(" + $(".product-section .option-framing input:checked").data("url") + ")");
        $(".main-product-gallery div:not(.other) .card__media.main_product_card_media").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url-ns") + ")",
        );
        $(".main-product-gallery div:not(.other) .card__media.main_product_card_media:last-child").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url") + ")",
        );
        $(".main-product-gallery div:not(.other) .card__media.wall_table_preview").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url-ns") + ")",
        );
        $(".main-product-gallery div:not(.other) .card__media.wall_table_preview:last-child").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url") + ")",
        );
        $(".product-images-zoom-slider div:not(.other) .card__media.main_product_card_media").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url-ns") + ")",
        );
        $(".product-images-zoom-slider div:not(.other) .card__media.main_product_card_media:last-child").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url") + ")",
        );
        $(".product-images-zoom-slider div:not(.other) .card__media.wall_table_preview").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url-ns") + ")",
        );
        $(".product-images-zoom-slider div:not(.other) .card__media.wall_table_preview:last-child").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url") + ")",
        );
      } else {
        console.log("<1");
        $(".size-and-more-detail-tab-item-card")
          .find(".size-and-more-img-wrap")
          .css("background-image", "url(" + $(".product-section .option-framing input:checked").data("url") + ")");
        $(".main-product-gallery div:not(.other) .card__media").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url") + ")",
        );
        $(".product-images-zoom-slider div:not(.other) .card__media").css(
          "background-image",
          "url(" + $(".product-section .option-framing input:checked").data("url") + ")",
        );
      }
    }

    // Product page: in-room background image for slide-wall-preview (from metaobject)
    const slideWallPreviewSelector =
      ".main-product-gallery .slide-wall-preview, " +
      ".product-images-zoom-slider .slide-wall-preview, " +
      ".main-thubnails .slide-wall-preview, " +
      ".custom-cart-gallery .slide-wall-preview, " +
      ".custom-cart-thumbnails .slide-wall-preview";
    const slideMainProductCardMediaSelector = ".main-product-gallery .main-view .card__inner";
    /** Upsell drawer (collection quick-shop / cart-upsell) uses .custom-cart-gallery, not .main-product-gallery only */
    const drawerUpsellCardInnerSelector =
      ".drawer__upsell-main-content .custom-cart-gallery .main-view .card__inner";

    function getFrameSizeFromPrintSizeOption($trigger) {
      let $checked = $();
      let $selectedOpt = $();
      if ($trigger && $trigger.length) {
        const $drawerRoot = $trigger.closest(".drawer__upsell-main");
        if ($drawerRoot.length) {
          $checked = $drawerRoot.find(".option-print-size input:checked").first();
          $selectedOpt = $drawerRoot.find(".option-print-size select option:selected").first();
        }
      }
      if (!$checked.length && !$selectedOpt.length) {
        $checked = $(
          ".product__info-wrapper .option-print-size input:checked, product-info .option-print-size input:checked",
        ).first();
        $selectedOpt = $(
          ".product__info-wrapper .option-print-size select option:selected, product-info .option-print-size select option:selected",
        ).first();
      }
      if (!$checked.length && !$selectedOpt.length) {
        $checked = $(".drawer__upsell-main .option-print-size input:checked").first();
        $selectedOpt = $(".drawer__upsell-main .option-print-size select option:selected").first();
      }
      return $checked.data("frame-size") || $selectedOpt.data("frame-size") || "size-large";
    }

    function setDataFrameSizeOnPrintPreviews(frameSize) {
      $(slideWallPreviewSelector).attr("data-frame-size", frameSize);
      $(slideMainProductCardMediaSelector).attr("data-frame-size", frameSize);
      $(drawerUpsellCardInnerSelector).attr("data-frame-size", frameSize);
    }

    function getInroomImageIndexFromFrameSize(frameSize) {
      if (!frameSize) return 0;
      const size = String(frameSize).toLowerCase();
      if (["size-mini", "size-small", "size-medium", "size-large"].includes(size)) return 0;
      if (["size-x-large", "size-oversized", "size-collector"].includes(size)) return 1;
      return 0;
    }

    function getFrameSizeForSizeGuideCard(cardId) {
      const map = {
        "size-Small": "size-small",
        "size-Medium": "size-medium",
        "size-Large": "size-large",
        "size-X-Large": "size-x-large",
        "size-Oversized": "size-oversized",
        "size-Collector": "size-collector",
      };
      return map[cardId || ""] || "size-large";
    }

    function updateSizeGuideInroomBackgrounds() {
      const desktopRaw = $(".main-product-gallery .slide-wall-preview").first().attr("data-inroom-desktop");
      if (!desktopRaw) return;

      const urls = desktopRaw.split("|||");
      if (!urls.length || !urls[0]) return;

      $(".size-and-more-detail-tab-item-card .card-item-image-wrapper.size-guide-image").each(function () {
        const $wrap = $(this);
        const cardId = $wrap.closest(".size-and-more-detail-tab-item-card").attr("id");
        const frameSize = getFrameSizeForSizeGuideCard(cardId);
        const index = getInroomImageIndexFromFrameSize(frameSize);
        const url = urls[index] || urls[0];
        if (url) {
          $wrap.css("background-image", 'url("' + url + '")');
        }
      });
    }

    function activateWallPreviewSlide() {
      const $gallery = $(".main-product-gallery.pswp-gallery");
      if (!$gallery.length || !$gallery.hasClass("slick-initialized")) return;
      const $slides = $gallery.find(".slick-slide:not(.slick-cloned)");
      let wallIndex = -1;
      $slides.each(function (i) {
        if ($(this).find(".slide-wall-preview").length) {
          wallIndex = i;
          return false;
        }
      });
      if (wallIndex >= 0) {
        $gallery.slick("slickGoTo", wallIndex);
      }
    }

    //Product page option frames size wall preview (+ upsell drawer on collection PLP)
    function applyPrintSizeFrameSizeAndBackgrounds({ activateSlide = false, $trigger = null } = {}) {
      const frameSize = getFrameSizeFromPrintSizeOption($trigger);
      setDataFrameSizeOnPrintPreviews(frameSize);
      updateSizeGuideInroomBackgrounds();
      if (activateSlide) activateWallPreviewSlide();
    }

    // Delegated so it survives section re-render (and works for radios + selects)
    $(document).on("change click", ".option-print-size input, .option-print-size select, .option-print-size label", function () {
      applyPrintSizeFrameSizeAndBackgrounds({ activateSlide: true, $trigger: $(this) });
    });

    if ($(".option-print-size input:checked").length > 0) {
      applyPrintSizeFrameSizeAndBackgrounds();
    }

    updateSizeGuideInroomBackgrounds();

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        // Variant changes can re-render the picker/gallery; wait a tick then re-apply size attrs
        setTimeout(() => {
          applyPrintSizeFrameSizeAndBackgrounds();
          updateSizeGuideInroomBackgrounds();
        }, 0);
      });
    }

    $(window).on("resize", function () {
      if ($(".slide-wall-preview[data-inroom-desktop]").length) {
        updateSizeGuideInroomBackgrounds();
      }
    });

    function normalizeFrameStyleClass(frameStyleValue) {
      const value = (frameStyleValue || "").toLowerCase();
      if (value.includes("shadow")) return "frame-style--sb";
      if (value.includes("no frame") || value.includes("print only")) return "frame-style--none";
      return "frame-style--pa";
    }

    function normalizeFrameColorClass(frameColorValue) {
      const value = (frameColorValue || "").toLowerCase().replace(" anti-glare", "").trim();
      if (!value || value.includes("no frame") || value.includes("print only")) return "frame-color--none";
      return `frame-color--${value.replace(/[^a-z0-9]+/g, "-")}`;
    }

    function updateMainProductCardFrameClasses() {
      // Keep PDP behavior (global selectors) to avoid breaking the product page picker
      const $frameColorInput = $(
        ".product__info-wrapper .option-framing input:checked, product-info .option-framing input:checked",
      ).first();
      const $frameStyleInput = $(
        ".product__info-wrapper .option-frame-style input:checked, product-info .option-frame-style input:checked",
      ).first();

      if (!$frameColorInput.length && !$frameStyleInput.length) {
        return;
      }

      const frameStyleClass = normalizeFrameStyleClass($frameStyleInput.val());
      const frameColorClass = normalizeFrameColorClass($frameColorInput.val());

      $(
        ".main-product-gallery .card__media.main_product_card_media .frame, " +
          ".main-product-gallery .card__media.wall_table_preview .frame, " +
          ".product-images-zoom-slider .card__media.main_product_card_media .frame, " +
          ".product-images-zoom-slider .card__media.wall_table_preview .frame, " +
          ".drawer__upsell-main-content .card__media.main_product_card_media .frame, " +
          ".drawer__upsell-main-content .card__media.wall_table_preview .frame",
      ).each(function () {
        const classList = (this.className.match(/frame-style--[^\s]+|frame-color--[^\s]+/g) || []).join(" ");
        if (classList) {
          $(this).removeClass(classList);
        }
        $(this).addClass(`${frameStyleClass} ${frameColorClass}`);
      });
    }

    function updateDrawerUpsellFrameClasses() {
      $(".drawer__upsell-main").each(function () {
        const $drawer = $(this);

        const $frameColorInput = $drawer
          .find(
            ".option-framing input:checked, " +
              'input[type="radio"][name="Framing"]:checked, ' +
              'input[type="radio"][name="Frame Color"]:checked',
          )
          .first();
        const $frameStyleInput = $drawer.find(".option-frame-style input:checked").first();

        if (!$frameColorInput.length && !$frameStyleInput.length) {
          return;
        }

        const hasStyle = $frameStyleInput.length > 0;
        const hasColor = $frameColorInput.length > 0;
        const frameStyleClass = hasStyle ? normalizeFrameStyleClass($frameStyleInput.val()) : "";
        const frameColorClass = hasColor ? normalizeFrameColorClass($frameColorInput.val()) : "";

        $drawer
          .find(
            ".drawer__upsell-main-content .card__media.main_product_card_media .frame, " +
              ".drawer__upsell-main-content .card__media.wall_table_preview .frame",
          )
          .each(function () {
            let toRemove = [];
            if (hasStyle) toRemove = toRemove.concat(this.className.match(/frame-style--[^\s]+/g) || []);
            if (hasColor) toRemove = toRemove.concat(this.className.match(/frame-color--[^\s]+/g) || []);
            if (toRemove.length) $(this).removeClass(toRemove.join(" "));

            const toAdd = [hasStyle ? frameStyleClass : "", hasColor ? frameColorClass : ""].filter(Boolean).join(" ");
            if (toAdd) $(this).addClass(toAdd);
          });
      });
    }

    updateMainProductCardFrameClasses();
    updateDrawerUpsellFrameClasses();

    $(document).on("click", ".option-framing label, .option-frame-style label", function () {
      setTimeout(() => {
        updateMainProductCardFrameClasses();
        updateDrawerUpsellFrameClasses();
      }, 50);
    });

    $(document).on(
      "change",
      ".option-framing input, .option-frame-style input, input[type='radio'][name='Framing'], input[type='radio'][name='Frame Color']",
      function () {
        setTimeout(() => {
          updateMainProductCardFrameClasses();
          updateDrawerUpsellFrameClasses();
        }, 50);
      },
    );

    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        setTimeout(() => {
          updateMainProductCardFrameClasses();
          updateDrawerUpsellFrameClasses();
        }, 50);
        setTimeout(function () {
          const frameSize = getFrameSizeFromPrintSizeOption(null);
          if (frameSize) {
            setDataFrameSizeOnPrintPreviews(frameSize);
          }
        }, 50);
      });
    }

    //Product page tabs
    if ($(".product-tabs-container").length) {
      if (window.matchMedia("(max-width: 767px)").matches) {
        $(".product-tabs-container .tab-content").each(function () {
          var tabID = $(this).attr("id");
          $(this).insertAfter($(".product-tabs-container .tab-button[aria-controls='" + tabID + "']"));
        });
      }

      let target = $(".product-tabs-container .tab-button");
      target.on("click", function () {
        $(this).parents(".product-tabs-container").find(".tab-content").hide();
        $(this).parents(".product-tabs-container").find(".tab-button div").html("+");
        const controls = $(this).attr("aria-controls");
        var that = this;

        $(".product-tabs-container .tab-content").each(function () {
          if (controls == $(this).attr("id")) {
            $(this).show();
            $(that).find("div").html("-");
          } else {
            $(this).hide();
          }
        });
      });
    }

    // Page accordions
    if ($(".page-tabs-container").length > 0) {
      if (window.matchMedia("(max-width: 767px)").matches) {
        $(".page-tabs-container .tab-content").each(function () {
          var tabID = $(this).attr("id");
          $(this).insertAfter($(".page-tabs-container .tab-button[aria-controls='" + tabID + "']"));
        });
      }

      let target = $(".page-tabs-container .tab-button");
      target.on("click", function () {
        $(this).parents(".page-tabs-container").find(".tab-content").hide();
        $(this).parents(".page-tabs-container").find(".tab-button div").html("+");
        const controls = $(this).attr("aria-controls");
        var that = this;

        $(".page-tabs-container .tab-content").each(function () {
          if (controls == $(this).attr("id")) {
            $(this).show();
            $(that).find("div").html("-");
          } else {
            $(this).hide();
          }
        });
      });
    }

    var $pdpMain = $(".product__media-wrapper .pswp-gallery");
    var $pdpThumbs = $(".product__media-wrapper .pswp-thumbnails");
    var pdpThumbsNavSel = ".product__media-wrapper .pswp-thumbnails";
    var pdpMainNavSel = ".product__media-wrapper .pswp-gallery";
    if (!$pdpMain.length || !$pdpThumbs.length) {
      $pdpMain = $(".pswp-gallery").first();
      $pdpThumbs = $(".pswp-thumbnails").first();
      pdpThumbsNavSel = ".pswp-thumbnails";
      pdpMainNavSel = ".pswp-gallery";
    }
    if ($pdpMain.length && $pdpThumbs.length) {
      var thumbVisibleCount = 7;
      var shouldLoopPdp = $pdpThumbs.children().length > thumbVisibleCount;
      //Product page main slider (linked to thumbnails via asNavFor; infinite must match thumbs or clones break sync)
      var main_gallery = $pdpMain.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        dots: true,
        infinite: shouldLoopPdp,
        asNavFor: pdpThumbsNavSel,
      });
      window.oldFrameStyle = "";
      //Product page thumbnail strip: infinite loop; sync with main is handled by asNavFor + focusOnSelect (not manual index handlers)
      var thumbnail_gallery = $pdpThumbs.slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        centerMode: true,
        infinite: shouldLoopPdp,
        prevArrow: $(".custom-slider-nav.slider-button--prev"),
        nextArrow: $(".custom-slider-nav.slider-button--next"),
        focusOnSelect: true,
        swipeToSlide: true,
        asNavFor: pdpMainNavSel,
      });

      // When the PDP loads initially is the Mini option already selected?
      const hasMini = $(".pdp-carousel-wrap").hasClass("is-mini");

      function isMiniMarked(el) {
        return el.classList.contains("mini-composite") || !!el.querySelector(".mini-composite");
      }
      function isSlideMain(el) {
        return el.classList.contains("slide-main") || !!el.querySelector(".slide-main");
      }

      // Keep rule:
      // - Mini mode: keep slides that are mini-marked OR slide-main
      // - Non-mini:  keep slides that are NOT mini-marked OR slide-main (so slide-main is never filtered out)
      function keepFn(el) {
        return hasMini ? isMiniMarked(el) || isSlideMain(el) : !isMiniMarked(el) || isSlideMain(el);
      }

      // Start the PDP with the correct images filtered in the carousels based on whether selected variant is Mini or not.
      [main_gallery, thumbnail_gallery].forEach(($g) => {
        $g.slick("slickUnfilter");
        $g.slick("slickFilter", function (i, el) {
          return keepFn(el);
        });
      });
      var filteredSlideCount = main_gallery.slick("getSlick")?.slideCount || 0;
      var shouldLoopFiltered = filteredSlideCount > thumbVisibleCount;
      main_gallery.slick("slickSetOption", "infinite", shouldLoopFiltered, true);
      thumbnail_gallery.slick("slickSetOption", "infinite", shouldLoopFiltered, true);

      $(".pdp-carousel-wrap").removeClass("loading");

      if (window.matchMedia("(max-width: 767px)").matches) {
        try {
          $pdpMain.slick("slickSetOption", "asNavFor", "", true);
        } catch (e) {
          /* noop */
        }
        try {
          $pdpThumbs.slick("unslick");
        } catch (e) {
          /* noop */
        }
      }

      $pdpMain.on("afterChange", function (event, slick, currentSlide) {
        if (currentSlide != 0) {
          $("#zoom-button").addClass("disable");
        } else {
          $("#zoom-button").removeClass("disable");
        }
      });
    }
    if ($(".custom-cart-gallery")) {
      var cartThumbVisibleCount = 7;
      var shouldLoopCart = $(".custom-cart-thumbnails").children().length > cartThumbVisibleCount;
      //Product page main slider
      $(".custom-cart-gallery").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: ".custom-cart-thumbnails",
        dots: true,
        infinite: shouldLoopCart,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: true,
              arrows: false,
            },
          },
        ],
      });
      //Product page main slider thumbnails
      $(".custom-cart-thumbnails").slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: ".custom-cart-gallery",
        dots: false,
        arrows: false,
        centerMode: true,
        infinite: shouldLoopCart,
        prevArrow: $(".custom-slider-nav.slider-button--prev"),
        nextArrow: $(".custom-slider-nav.slider-button--next"),
        focusOnSelect: true,
        swipeToSlide: true,
      });

      if (window.matchMedia("(max-width: 767px)").matches) {
        try {
          $(".custom-cart-gallery").slick("slickSetOption", "asNavFor", "", true);
        } catch (e) {
          /* noop */
        }
        try {
          $(".custom-cart-thumbnails").slick("unslick");
        } catch (e) {
          /* noop */
        }
      }

      $(".custom-cart-gallery").on("afterChange", function (event, slick, currentSlide) {
        if (currentSlide != 0) {
          $("#zoom-button").addClass("disable");
        } else {
          $("#zoom-button").removeClass("disable");
        }
      });
    }

    $(document).ready(function () {
      $(".cart-drawer-collection-slider").slick({
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "0px",
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $(".slider-drawer-button--prev"), // Target the custom previous button
        nextArrow: $(".slider-drawer-button--next"), // Target the custom next button
      });
    });

    // Ensure the next and previous buttons work correctly
    $(".slider-drawer-button--prev").on("click", function () {
      $(".cart-drawer-collection-slider").slick("slickPrev");
    });

    $(".slider-drawer-button--next").on("click", function () {
      $(".cart-drawer-collection-slider").slick("slickNext");
    });

    $(".add-to-cart-btn").on("click", function (e) {
      e.preventDefault();
      var productId = $(this).data("product-id");
      var form = $("#add-to-cart-form-" + productId);
      var variantId = form.find('input[name="id"]').val();

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {quantity: 1, id: variantId},
        dataType: "json",
        success: function (response) {
          updateCartItems();
          updateCartBubble();
        },
        error: function (xhr, status, error) {
          console.log("Error adding product to cart:", error);
          alert("Failed to add product to cart.");
        },
      });
    });

    function updateCartItems() {
      $.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (data) {
          var updatedCartItems = $(data).find("#CartDrawer-CartItems");
          var updatedCartDiscount = $(data).find("#discountCalc");

          $("#CartDrawer-CartItems").html(updatedCartItems.html());
          $("#discountCalc").html(updatedCartDiscount.html());

          var updatedTotals = $(data).find(".totals__total-value").html();
          $(".totals__total-value").html(updatedTotals);
        },
        error: function (xhr, status, error) {
          console.log("Error fetching updated cart items:", error);
        },
      });
    }

    function updateCartBubble() {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cart) {
          var itemCount = cart.item_count;
          var cartBubbleHeader = $("#header-cart-count");
          var cartBubbleDrawer = $(".cart-count-bubble span");
          cartBubbleHeader.text(itemCount);
          cartBubbleDrawer.text(itemCount);
        },
        error: function (xhr, status, error) {
          console.log("Error updating cart bubble:", error);
        },
      });
    }

    //Favorite products slider
    if ($(".favorite-products .cb-favorite-slider").length) {
      $(".cb-favorite-slider .collection-list").slick({
        slidesToShow: 4,
        // slidesToScroll: 1,
        dots: false,
        infinite: true,
        centerMode: false,
        arrows: true,
        prevArrow: $(".cb-favorite-slider .slider-button--prev"),
        nextArrow: $(".cb-favorite-slider .slider-button--next"),
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              centerMode: true,
            },
          },
          {
            breakpoint: 1079,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1380,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      });
    }

    if ($(".favorite-products:not(.best-potography) .cb-on-sale-slider").length) {
      var onSaleCarouselTarget = $(".cb-on-sale-slider .collection-list");
      onSaleCarouselTarget.flickity({
        cellAlign: "left",
        contain: true,
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        pageDots: true,
      });
      $(".cb-on-sale-slider .slider-button--prev").on("click", function () {
        onSaleCarouselTarget.flickity("previous");
      });
      $(".cb-on-sale-slider .slider-button--next").on("click", function () {
        onSaleCarouselTarget.flickity("next");
      });
    }

    if ($(".cb-two-column-callout-slider.init-slider").length) {
      var calloutTarget = $(".cb-two-column-callout-slider .callout-list");
      calloutTarget.flickity({
        cellAlign: "left",
        contain: true,
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        pageDots: true,
        groupCells: false,
      });
      $(".cb-two-column-callout-slider.init-slider .slider-button--prev").on("click", function () {
        calloutTarget.flickity("previous");
      });
      $(".cb-two-column-callout-slider.init-slider .slider-button--next").on("click", function () {
        calloutTarget.flickity("next");
      });
      calloutTarget.on("change.flickity", function (event, index) {
        var button_index = index + 1;
        $("#slidertext-" + button_index)
          .addClass("active")
          .siblings()
          .removeClass("active");
      });
    }

    if ($(".favorite-products.best-potography").length) {
      var onSaleCarouselTarget = $(".cb-on-sale-slider .collection-list");
      onSaleCarouselTarget.flickity({
        cellAlign: "left",
        contain: true,
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        pageDots: false,
      });
      $(".cb-on-sale-slider .slider-button--prev").on("click", function () {
        onSaleCarouselTarget.flickity("previous");
      });
      $(".cb-on-sale-slider .slider-button--next").on("click", function () {
        onSaleCarouselTarget.flickity("next");
      });
    }

    //Destination search

    $("#destination-search[data-search]").on("keyup", function () {
      let searchVal = $(this).val();
      let filterItems = $("[data-filter-item]");
      let filterListBlock = $("[data-filter-list-block]");

      if (searchVal !== "") {
        filterItems.addClass("hidden");
        // $('[data-filter-item][data-filter-name*="' + searchVal.toLowerCase() + '"]').removeClass('hidden');
        filterListBlock.each(function () {
          let block = $(this);
          let matchingItems = block.find('[data-filter-item][data-filter-name*="' + searchVal.toLowerCase() + '"]');

          if (matchingItems.length > 0) {
            matchingItems.removeClass("hidden");
            block.removeClass("hidden");
          } else {
            block.addClass("hidden");
          }
        });
      } else {
        filterItems.removeClass("hidden");
        filterListBlock.removeClass("hidden");
      }
    });

    $(document).on("change", "#anti-glare-cart-drawer", function () {
      $(this)
        .closest(".drawer__upsell-main")
        .find(".js-cb-framing-swatch-container label")
        .removeClass("pseudo-checked-swatch");

      if (!this.checked) {
        $("#anti-glare-cart-drawer").attr("checked", "true");
        $("#anti-glare-cart-drawer").prop("checked", true);

        let selectedFramingSwatch = $(this)
          .closest(".drawer__upsell-main")
          .find('input[type="radio"][name="Framing"]:checked').length
          ? $(this).closest(".drawer__upsell-main").find('input[type="radio"][name="Framing"]:checked')
          : $(this).closest(".drawer__upsell-main").find('input[type="radio"][name="Frame Color"]:checked');
        console.log(selectedFramingSwatch);
        if (selectedFramingSwatch.length === 1) {
          let framingContainer = $(selectedFramingSwatch).parents(".js-cb-framing-swatch-container");

          if (framingContainer.length === 1) {
            let framingHandle = $(framingContainer).data("framing_swatch");

            let antiGlareFramingContainer = $(this)
              .closest(".drawer__upsell-main")
              .find('.js-cb-framing-swatch-container[data-framing_swatch="' + framingHandle + " Anti-Glare" + '"]');
            if (antiGlareFramingContainer.length === 1) {
              $(selectedFramingSwatch).removeAttr("checked");
              $(selectedFramingSwatch).prop("checked", false);

              $(antiGlareFramingContainer).find("label").click();
              $(framingContainer).find("label").addClass("pseudo-checked-swatch");
            }
          }
        }
      } else {
        document.getElementById(`anti-glare-cart-drawer`).removeAttribute("checked");
        $("#anti-glare-cart-drawer").removeAttr("checked");
        $("#anti-glare-cart-drawer").prop("checked", false);

        let selectedFramingSwatch = $(this)
          .closest(".drawer__upsell-main")
          .find('input[type="radio"][name="Framing"]:checked').length
          ? $(this).closest(".drawer__upsell-main").find('input[type="radio"][name="Framing"]:checked')
          : $(this).closest(".drawer__upsell-main").find('input[type="radio"][name="Frame Color"]:checked');
        if (selectedFramingSwatch.length === 1) {
          let framingContainer = $(selectedFramingSwatch).parents(".js-cb-framing-swatch-container");

          if (framingContainer.length === 1) {
            let framingHandle = $(framingContainer).data("framing_swatch");

            let antiGlareFramingContainer = $(this)
              .closest(".drawer__upsell-main")
              .find(
                '.js-cb-framing-swatch-container[data-framing_swatch="' + framingHandle.replace(" Anti-Glare", "") + '"]',
              );

            if (antiGlareFramingContainer.length === 1) {
              $(selectedFramingSwatch).removeAttr("checked");
              $(selectedFramingSwatch).prop("checked", false);

              $(antiGlareFramingContainer).find("label").click();
            }
          }
        }
      }
    });

    $("#anti-glare").change(function () {
      $(this).closest("product-info").find(".js-cb-framing-swatch-container label").removeClass("pseudo-checked-swatch");

      if (this.checked) {
        $(this).attr("checked", "true");
        $(this).prop("checked", true);

        let selectedFramingSwatch = $(this).closest("product-info").find('input[type="radio"][name="Framing"]:checked')
          .length
          ? $(this).closest("product-info").find('input[type="radio"][name="Framing"]:checked')
          : $(this).closest("product-info").find('input[type="radio"][name="Frame Color"]:checked');

        if (selectedFramingSwatch.length === 1) {
          let framingContainer = $(selectedFramingSwatch).parents(".js-cb-framing-swatch-container");

          console.log("cdebug framingContainer", framingContainer);
          console.log("cdebug selectedFramingSwatch", selectedFramingSwatch);

          if (framingContainer.length === 1) {
            let framingHandle = $(framingContainer).data("framing_swatch");

            let antiGlareFramingContainer = $(this)
              .closest("product-info")
              .find('.js-cb-framing-swatch-container[data-framing_swatch="' + framingHandle + " Anti-Glare" + '"]');
            if (antiGlareFramingContainer.length === 1) {
              $(selectedFramingSwatch).removeAttr("checked");
              $(selectedFramingSwatch).prop("checked", false);

              $(antiGlareFramingContainer).find("label").click();
              setTimeout(() => {
                $(framingContainer).find("label").addClass("pseudo-checked-swatch");
              }, 0);
            }
          }
        }
      } else {
        document.getElementById(`anti-glare`).removeAttribute("checked");
        $(this).removeAttr("checked");
        $(this).prop("checked", false);

        let selectedFramingSwatch = $(this).closest("product-info").find('input[type="radio"][name="Framing"]:checked')
          .length
          ? $(this).closest("product-info").find('input[type="radio"][name="Framing"]:checked').length
          : $(this).closest("product-info").find('input[type="radio"][name="Frame Color"]:checked');
        if (selectedFramingSwatch.length === 1) {
          let framingContainer = $(selectedFramingSwatch).parents(".js-cb-framing-swatch-container");

          if (framingContainer.length === 1) {
            let framingHandle = $(framingContainer).data("framing_swatch");

            let antiGlareFramingContainer = $(this)
              .closest("product-info")
              .find(
                '.js-cb-framing-swatch-container[data-framing_swatch="' + framingHandle.replace(" Anti-Glare", "") + '"]',
              );

            if (antiGlareFramingContainer.length === 1) {
              $(selectedFramingSwatch).removeAttr("checked");
              $(selectedFramingSwatch).prop("checked", false);

              $(antiGlareFramingContainer).find("label").click();
            }
          }
        }
      }
    });

    // $('header-menu details').on('mouseover', function() {
    //   console.log('content')
    //   $(this).attr('open', true);
    // }).on('mouseout', function() {
    //   $(this).attr('open', false);
    // });

    $("header-menu details")
      .on("click", function (e) {
        e.preventDefault();

        document.querySelectorAll("header-menu details").forEach((detail) => {
          detail.removeAttribute("open");
        });

        if (!e.target.classList.contains("mega-menu__content__bg")) {
          $(this).attr("open", true); // open
          $(this).find("[js-mega-menu-content]").first().addClass("open");

          $("[js-navigation-closed]").addClass("active");
        }
      })
      .on("mouseout", function () {
        //$(this).attr('open', false);
      });

    // Change mega menu dropdown image on link hover
    // This was built even though not intended for this custom theme
    // To enable need to add data-bg-img attribute to links in /header-mega-menu file
    // $('.mega-menu__list ul.list-unstyled a').on('mouseover', function() {
    //     let megamenuImgBlock =  $('.js-dropdown-image-block img');
    //     let megamenuImgBlockContent =  $('.js-dropdown-image .dropdown-image-content');
    //     let hoverImgData = $(this).data('bg-img');

    //     if (megamenuImgBlock.length > 0 && hoverImgData !== undefined) {

    //         if (megamenuImgBlockContent.length > 0) {
    //             $(megamenuImgBlock).attr('src', hoverImgData);
    //             $(megamenuImgBlockContent).addClass('hidden');
    //         }
    //     }
    // }).on('mouseout', function() {
    //     let megamenuImgBlock =  $('.js-dropdown-image-block img');
    //     let megamenuImgBlockContent =  $('.js-dropdown-image .dropdown-image-content');

    //     if (megamenuImgBlock.length > 0) {
    //         if (megamenuImgBlockContent.length > 0) {
    //             $(megamenuImgBlock).attr('src', $(megamenuImgBlock).data('cb-src'));
    //             $(megamenuImgBlockContent).removeClass('hidden');
    //         }
    //     }
    // });

    // page filters LIST
    $(".page-filters-container .page-filters-list .page-filter-category").on("click", function (e) {
      e.preventDefault();
      let searchVal = $(this).data("filter_val");
      let filterItems = $("[data-page-filter-item]");
      $(this).removeClass("active");

      $(this).parents(".page-filters-list").find(".page-filter-category").removeClass("active");
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
      }
      if (searchVal !== "" && searchVal.toLowerCase() !== "all") {
        filterItems.addClass("hidden");
        $(filterItems).each(function () {
          let full_filter_val = $(this).data("page-filters");

          if (full_filter_val.includes(searchVal.toLowerCase())) {
            $(this).removeClass("hidden");
          }
        });
      } else {
        filterItems.removeClass("hidden");
      }
    });

    // load more blogs
    var currentPage = 1;
    $("#blog-load-more").click(function (e) {
      e.preventDefault();
      currentPage = currentPage + 1;
      let nextPageUrl = $(this).attr("data-pag-url");
      let nextUrl = nextPageUrl.concat(currentPage);
      $.ajax({
        url: nextUrl,
        type: "GET",
        beforeSend: function () {
          //$('#blog-load-more').remove();
        },
      }).done(function (data) {
        $(".cb-blog-articles").append($(data).find(".cb-blog-articles").html());
      });
    });

    if (window.matchMedia("(min-width: 1280px)").matches) {
      if ($(".destination-section").length) {
        $(".search-container").insertAfter(".hero-banner h1:last-child");
      }
    }

    if (window.matchMedia("(min-width: 1280px)").matches) {
      if ($(".js-search-section").length) {
        $(".search-container").insertAfter(".hero-banner h1:last-child");
      }
    }

    // gift card validation
    $('.pdp-gift-card form[action="/cart/add"] button[type="submit"]').click(function (e) {
      $(".cb-gc-required").removeClass("error");
      $(".cb-product-card.err-msg").addClass("hidden");
      $(".cb-gc-required").each(function () {
        let val = $(this).find("input").val();
        if (val === "") {
          e.preventDefault();
          $(this).addClass("error");
          $(".cb-product-card.err-msg").removeClass("hidden");
        }
      });
    });

    $(".cb-gc-required input").each(function () {
      $(this).on("blur", function () {
        $(".cb-product-card.err-msg").addClass("hidden");
        $(".cb-gc-required").each(function () {
          let val = $(this).find("input").val();
          if (val === "") {
            $(".cb-product-card.err-msg").removeClass("hidden");
          }
        });
      });
    });

    // footer newsletter subscribe validation
    $('.footer-block form#email_signup button[type="submit"]').click(function (e) {
      $(".newsletter-tips").addClass("hidden");

      if ($(".footer-block form#email_signup #confirm").prop("checked") === false) {
        e.preventDefault();
        $(".newsletter-tips").removeClass("hidden");
      }
    });

    if ($(".travel-places-slider").length) {
      //custom code
      Flickity.createMethods.push("_createPrevNextCells");

      Flickity.prototype._createPrevNextCells = function () {
        this.on("select", this.setPrevNextCells);
      };

      Flickity.prototype.setPrevNextCells = function () {
        changeSlideClasses(this.previousSlide, "remove", "is-previous");
        changeSlideClasses(this.previousPrevSlide, "remove", "is-previous-previous");
        changeSlideClasses(this.nextSlide, "remove", "is-next");
        changeSlideClasses(this.nextNextSlide, "remove", "is-next-next");

        if (this.selectedIndex - 1 < 0) {
          this.previousSlide = this.slides[this.slides.length - 1];
          this.previousPrevSlide = this.slides[this.slides.length - 2];
        } else {
          this.previousSlide = this.slides[this.selectedIndex - 1];
          this.previousPrevSlide = this.slides[this.selectedIndex - 2];
        }

        if (this.selectedIndex === 1) {
          this.previousPrevSlide = this.slides[this.slides.length - 1];
        } else {
        }

        if (this.selectedIndex + 1 === this.slides.length) {
          this.nextSlide = this.slides[0];
          this.nextNextSlide = this.slides[1];
        } else {
          this.nextSlide = this.slides[this.selectedIndex + 1];
          this.nextNextSlide = this.slides[this.selectedIndex + 2];
        }

        if (this.selectedIndex + 2 === this.slides.length) {
          this.nextNextSlide = this.slides[0];
        } else {
        }

        changeSlideClasses(this.previousSlide, "add", "is-previous");
        changeSlideClasses(this.previousPrevSlide, "add", "is-previous-previous");
        changeSlideClasses(this.nextSlide, "add", "is-next");
        changeSlideClasses(this.nextNextSlide, "add", "is-next-next");
      };
      function changeSlideClasses(slide, method, className) {
        if (!slide) {
          return;
        }
        slide.getCellElements().forEach(function (cellElem) {
          cellElem.classList[method](className);
        });
      }

      var sl_options = {
        cellAlign: "left",
        wrapAround: false,
        draggable: true,
        prevNextButtons: false,
        pageDots: false,
      };

      if (window.matchMedia("(min-width: 768px)").matches) {
        sl_options.wrapAround = true;
      }
      $(".travel-places-slider").each(function () {
        var travel = $(this);
        travel.flickity(sl_options);

        $(this)
          .parents(".travel-items-container")
          .find(".slider-button--prev")
          .on("click", function () {
            travel.flickity("previous");
          });
        $(this)
          .parents(".travel-items-container")
          .find(".slider-button--next")
          .on("click", function () {
            travel.flickity("next");
          });
      });
    }

    // if ($('.cb-auth').length) {
    //   var hash = window.location.hash;
    //   if(hash == '#recover') {
    //     $('#create-account-column').hide();
    //     $('body').addClass('hide-reg');
    //   }else {
    //     $('#create-account-column').show();
    //     $('body').removeClass('hide-reg');
    //   }
    // }

    // $('.zalupa_login').on('click',function(){
    //   var hash = window.location.hash;
    //   if(hash != '#recover') {
    //     $('#create-account-column').hide();
    //     $('body').addClass('hide-reg')
    //   } else {
    //     $('#create-account-column').show();
    //     $('body').removeClass('hide-reg');
    //   }
    // })

    if ($(".announcement-bar-section").length && $(".shopify-section-header-sticky").length) {
      $(".announcement-bar-section").prependTo(".shopify-section-header-sticky");
    }

    // Travel Guide Post sliders
    $(".tgi-slider").slick();
    $(".tgi-products").slick();
  });

  setTimeout(function () {
    $(".product-images-zoom-slider")
      .find(".product-images-slider.gallery-slider")
      .find(".swiper-slide img")
      .click(function (e) {
        var $swiperSlide = $(this).closest(".swiper-slide");

        // if($(this).closest('.main-view').length > 0 || $(this).closest('.slide-wall-preview').length > 0) {
        //   return;
        // }

        if ($swiperSlide.hasClass("swiper-slide-active")) {
          // Get the image source from the clicked image
          var imgSrc = $(this).attr("src");

          if (imgSrc) {
            // Show a loading indicator while the image loads
            $(".product-zoom-wrapp").find("img").hide();
            $(".product-zoom-wrapp").css("display", "flex");
            $(".loading-spinner").show(); // Assuming you have a loading spinner element

            // Preload the image
            var img = new Image();
            img.src = imgSrc;

            // Once the image is fully loaded, set the source and show it
            img.onload = function () {
              $(".product-zoom-wrapp").find("img").attr("src", imgSrc);
              $(".loading-spinner").hide(); // Hide the spinner once the image loads
              $(".product-zoom-wrapp").find("img").fadeIn(); // Use fadeIn for a smooth transition
              $("body").css("overflow", "hidden");
              update_popup_image(); // Call your function after the image is loaded
            };
          }
        }

        e.stopPropagation(); // Prevent the event from bubbling up
      });

    $(".product-zoom-wrapp").click(function () {
      $(".product-zoom-wrapp").css("display", "none");
      $("body").css("overflow", "auto");
    });

    function update_popup_image() {
      $(".product-zoom-wrapp")
        .find("img")
        .each(function () {
          var img = $(this);
          var imageElement = img[0]; // Get the DOM element from the jQuery object

          // Check if the image has loaded
          if (imageElement.complete) {
            addOrientationClass(img, imageElement);
          } else {
            // If the image hasn't loaded yet, use the load event
            img.on("load", function () {
              addOrientationClass(img, imageElement);
            });
          }
        });
    }

    function addOrientationClass(img, imageElement) {
      if (imageElement.naturalWidth >= imageElement.naturalHeight) {
        img.addClass("horizontal");
        // console.log("The image is horizontal, class added: 'horizontal'"+imageElement.naturalHeight+'==='+imageElement.naturalWidth);
      } else if (imageElement.naturalWidth < imageElement.naturalHeight) {
        img.addClass("vertical");
        // console.log("The image is vertical, class added: 'vertical'"+imageElement.naturalHeight+'==='+imageElement.naturalWidth);
      } else {
        img.addClass("square");
        // console.log("The image is square, class added: 'square'");
      }
    }
  }, 2000);
})(jQuery);

$(document).on("click", function () {
  if ($(".variant-picker__container").hasClass("active")) {
    $("body").css({overflow: "hidden"});
  } else if (!$(".variant-picker__container").hasClass("active")) {
    $("body").css({overflow: "scroll"});
  }
});

// Related Products Section Script Start

new Swiper(".related-products-list-wrapper", {
  slidesPerView: 3.8,
  spaceBetween: 64,
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    990: {
      slidesPerView: 3.85,
      spaceBetween: 65,
    },
    650: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    500: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    320: {
      slidesPerView: 1.2,
      spaceBetween: 30,
    },
  },
});

// Related Products Section Script End

// Related Products Section Script Start

new Swiper(".images-banner-item-wrapper", {
  slidesPerView: 4,
  spaceBetween: 16,
  breakpoints: {
    990: {
      slidesPerView: 4,
    },
    650: {
      slidesPerView: 3.5,
    },
    500: {
      slidesPerView: 3,
    },
    320: {
      slidesPerView: 2.2,
    },
  },
});

// Related Products Section Script End

// begin drawer filter search function
document.addEventListener("DOMContentLoaded", function () {
  var filterSearchInput = document.querySelectorAll(".gm-filter-search-container input");

  filterSearchInput.forEach((searchIn) => {
    searchIn.addEventListener("keyup", function (event) {
      var filterItems = this.closest(".mobile-facets__submenu").querySelectorAll(".mobile-facets__item");
      console.log("Enter Text", this.value);
      const in_txt = this.value.toLowerCase();
      filterItems.forEach((item) => {
        item.classList.remove("is-hidden");
      });
      if (in_txt != "") {
        filterItems.forEach((item) => {
          const item_text = item.querySelector(".facet-checkbox__text").innerText.toLowerCase();
          if (item_text.indexOf(in_txt) == -1) {
            // console.log("search result", item_text.indexOf(in_txt));
            item.classList.add("is-hidden");
          }
        });
      }
    });
  });

  // const pro_cnt = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').getAttribute("data-pro-cnt");
  // document.querySelector(".mobile-drawer-filter-result-count").innerHTML = "(" + pro_cnt + ")";
});

window.addEventListener("load", function () {
  const searchParams = new URLSearchParams(window.location.search);

  // Remove filter-related params (those starting with 'filter.')
  const sort_type = searchParams.get("sort_by");

  // console.log("sort_type", sort_type);

  if (sort_type) {
    document.querySelector(".gm-sort-accordion input.mobile-facets__checkbox[data-sort-type='" + sort_type + "']").checked =
      true;
  }
});
